import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconMicOn",
  "use": "IconMicOn-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"IconMicOn\"><path fill=\"#777\" d=\"M12 14c-1.66 0-3-1.34-3-3V5c0-1.66 1.34-3 3-3s3 1.34 3 3v6c0 1.66-1.34 3-3 3zm5.91-3c.61 0 1.1.54 1 1.14-.49 3-2.89 5.35-5.91 5.78V20c0 .55-.45 1-1 1s-1-.45-1-1v-2.08a6.993 6.993 0 0 1-5.91-5.78c-.09-.6.39-1.14 1-1.14.49 0 .9.36.98.85C7.48 14.2 9.53 16 12 16c2.47 0 4.52-1.8 4.93-4.15.08-.49.49-.85.98-.85z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol